import React, { useState } from 'react';
import { Search, CheckCircle, XCircle, Monitor, Calendar, Download, Clock, LogIn, LogOut } from 'lucide-react';
import { mockLoginLogs } from '../data/mockData';
import './Historique.css';

const Historique: React.FC = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [filterResult, setFilterResult] = useState('Tous');
  const [filterDate, setFilterDate] = useState('');

  const filtered = mockLoginLogs.filter(log => {
    const matchSearch = searchQuery === '' ||
      log.username.toLowerCase().includes(searchQuery.toLowerCase()) ||
      log.email.toLowerCase().includes(searchQuery.toLowerCase()) ||
      log.ip.includes(searchQuery);
    const matchResult = filterResult === 'Tous' || log.resultat === filterResult;
    const matchDate = filterDate === '' || log.date === filterDate;
    return matchSearch && matchResult && matchDate;
  });

  const totalConnexions = mockLoginLogs.length;
  const succesCount = mockLoginLogs.filter(l => l.resultat === 'succes').length;
  const echecCount = mockLoginLogs.filter(l => l.resultat === 'echec').length;

  return (
    <div className="hist-page">
      {/* Stats */}
      <div className="hist-stats">
        <div className="hist-stat-card">
          <div className="hist-stat-icon hist-si-total"><Monitor size={20} /></div>
          <div className="hist-stat-info">
            <span className="hist-stat-label">TOTAL CONNEXIONS</span>
            <span className="hist-stat-value">{totalConnexions}</span>
          </div>
        </div>
        <div className="hist-stat-card">
          <div className="hist-stat-icon hist-si-success"><CheckCircle size={20} /></div>
          <div className="hist-stat-info">
            <span className="hist-stat-label">RÉUSSIES</span>
            <span className="hist-stat-value hist-val-success">{succesCount}</span>
          </div>
        </div>
        <div className="hist-stat-card">
          <div className="hist-stat-icon hist-si-fail"><XCircle size={20} /></div>
          <div className="hist-stat-info">
            <span className="hist-stat-label">ÉCHOUÉES</span>
            <span className="hist-stat-value hist-val-fail">{echecCount}</span>
          </div>
        </div>
      </div>

      {/* Toolbar */}
      <div className="hist-toolbar">
        <div className="hist-toolbar-left">
          <div className="hist-search">
            <Search size={16} className="hist-search-icon" />
            <input
              type="text"
              placeholder="Rechercher par nom, email ou IP..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
          <select
            value={filterResult}
            onChange={(e) => setFilterResult(e.target.value)}
            className="hist-select"
          >
            <option value="Tous">Tous les résultats</option>
            <option value="succes">Réussies</option>
            <option value="echec">Échouées</option>
          </select>
          <div className="hist-date-wrap">
            <Calendar size={14} className="hist-date-icon" />
            <input
              type="date"
              value={filterDate}
              onChange={(e) => setFilterDate(e.target.value)}
              className="hist-date-input"
            />
          </div>
        </div>
        <button className="hist-btn-export">
          <Download size={14} /> Exporter CSV
        </button>
      </div>

      {/* Count */}
      <p className="hist-count">{filtered.length} entrée{filtered.length > 1 ? 's' : ''}</p>

      {/* Table */}
      <div className="hist-table-wrap">
        <table className="hist-table">
          <thead>
            <tr>
              <th>Utilisateur</th>
              <th>Date</th>
              <th>Connexion</th>
              <th>Déconnexion</th>
              <th>Durée</th>
              <th>Adresse IP</th>
              <th>Appareil</th>
              <th>Résultat</th>
              <th>Détail</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map(log => (
              <tr key={log.id} className={log.resultat === 'echec' ? 'hist-row-fail' : ''}>
                <td>
                  <div className="hist-cell-user">
                    <div className={`hist-avatar ${log.resultat === 'echec' ? 'hist-avatar-fail' : ''}`}>
                      {log.username.charAt(0).toUpperCase()}
                    </div>
                    <div>
                      <span className="hist-username">{log.username}</span>
                      <span className="hist-email">{log.email}</span>
                    </div>
                  </div>
                </td>
                <td>
                  <span className="hist-date">{new Date(log.date).toLocaleDateString('fr-FR')}</span>
                </td>
                <td>
                  <div className="hist-time-cell">
                    <LogIn size={13} className="hist-time-icon hist-icon-login" />
                    <span className="hist-time">{log.heure}</span>
                  </div>
                </td>
                <td>
                  {log.heureDeconnexion ? (
                    <div className="hist-time-cell">
                      <LogOut size={13} className="hist-time-icon hist-icon-logout" />
                      <span className="hist-time">{log.heureDeconnexion}</span>
                    </div>
                  ) : (
                    <span className="hist-no-data">—</span>
                  )}
                </td>
                <td>
                  {log.duree ? (
                    <div className="hist-duree">
                      <Clock size={13} className="hist-duree-icon" />
                      <span>{log.duree}</span>
                    </div>
                  ) : (
                    <span className="hist-no-data">—</span>
                  )}
                </td>
                <td className="hist-ip">{log.ip}</td>
                <td className="hist-device">{log.appareil}</td>
                <td>
                  <span className={`hist-result-badge ${log.resultat === 'succes' ? 'hist-badge-success' : 'hist-badge-fail'}`}>
                    {log.resultat === 'succes'
                      ? <><CheckCircle size={12} /> Succès</>
                      : <><XCircle size={12} /> Échec</>
                    }
                  </span>
                </td>
                <td className="hist-detail">
                  {log.motifEchec || '—'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {filtered.length === 0 && (
          <div className="hist-empty">Aucune entrée ne correspond aux critères.</div>
        )}
      </div>
    </div>
  );
};

export default Historique;
